/// <amd-module name="TFS/Admin/Groups/Pivots/ServicePrincipals/Redux/ServicePrincipalsPivotActions" />
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";
import { IPermissionPage, SearchStatus } from "TFS/Admin/Groups/Common/Constants";
import { CustomGraphServicePrincipal, ServicePrincipalsOperation } from "TFS/Admin/Groups/Common/Contracts";
import { MessageCardSeverity } from "VSSUI/MessageCard";

/**
 * Actions for ServicePrincipals view
 */
export const ServicePrincipalsPivotActions = {
    initView: (scopeDescriptor?: string, permissionPage?: IPermissionPage) =>
        createAction(ServicePrincipalsPivotActionTypes.InitView, { scopeDescriptor, permissionPage }),
    disposeView: () => createAction(ServicePrincipalsPivotActionTypes.DisposeView),
    initialServicePrincipalsLoadSucceeded: (servicePrincipals: CustomGraphServicePrincipal[], continuationToken?: string[]) =>
        createAction(ServicePrincipalsPivotActionTypes.InitialServicePrincipalsLoadSucceeded, { servicePrincipals, continuationToken }),
    servicePrincipalsLoadFailed: () => createAction(ServicePrincipalsPivotActionTypes.ServicePrincipalsLoadFailed),
    fetchMoreServicePrincipalsSucceeded: (servicePrincipals: CustomGraphServicePrincipal[], continuationToken?: string[]) =>
        createAction(ServicePrincipalsPivotActionTypes.FetchMoreServicePrincipalsSucceeded, { servicePrincipals, continuationToken }),
    onRenderMissingItem: (continuationToken?: string[], scopeDescriptor?: string, permissionPage?: IPermissionPage) =>
        createAction(ServicePrincipalsPivotActionTypes.OnRenderMissingItem, { continuationToken, scopeDescriptor, permissionPage }),
    servicePrincipalOperationStatus: (operation: ServicePrincipalsOperation, resultMessage: string, severity: MessageCardSeverity) =>
        createAction(ServicePrincipalsPivotActionTypes.ServicePrincipalOperationStatus, { operation, resultMessage, severity }),
    onDismissMessageCard: () => createAction(ServicePrincipalsPivotActionTypes.DismissMessageCard),

    // Search
    searchServicePrincipals: (
        newKeyword?: string,
        oldKeyword?: string,
        scopeDescriptor?: string,
        isExpandSearchToOrg?: boolean,
        permissionPage?: IPermissionPage
    ) => createAction(ServicePrincipalsPivotActionTypes.SearchServicePrincipals, { newKeyword, oldKeyword, scopeDescriptor, isExpandSearchToOrg, permissionPage }),
    updateSearchStatus: (searchStatus: SearchStatus) => createAction(ServicePrincipalsPivotActionTypes.UpdateSearchStatus, searchStatus),
    updateSearchResult: (keyword: string, result: any[], hasMore: boolean) =>
        createAction(ServicePrincipalsPivotActionTypes.UpdateSearchResult, { result, hasMore, keyword })
};

export const enum ServicePrincipalsPivotActionTypes {
    InitView = "ServicePrincipalsPivot/Init",
    DisposeView = "ServicePrincipalsPivot/Dispose",
    InitialServicePrincipalsLoadSucceeded = "ServicePrincipalsPivot/InitialServiceprincipalsLoadSucceeded",
    ServicePrincipalsLoadFailed = "ServicePrincipalsPivot/ServicePrincipalsLoadFailed",
    FetchMoreServicePrincipalsSucceeded = "ServicePrincipalsPivot/FetchMoreServicePrincipalsSucceeded",
    OnRenderMissingItem = "ServicePrincipalsPivot/OnRenderMissingItem",
    ServicePrincipalOperationStatus = "ServicePrincipalsPivot/ServicePrincipalOperationStatus",
    DismissMessageCard = "ServicePrincipalsPivot/DismissMessageCard",

    // Search
    SearchServicePrincipals = "ServicePrincipalsPivot/SearchServiceprincipals",
    UpdateSearchStatus = "ServicePrincipalsPivot/UpdateSearchStatus",
    UpdateSearchResult = "ServicePrincipalsPivot/UpdateSearchResult"
}

export type ServicePrincipalsPivotActions = ActionsUnion<typeof ServicePrincipalsPivotActions>;
